var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLivetracksix(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 28,
    viewBox: "0 0 20 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 13.3307C9.11529 13.3307 8.26745 12.9795 7.64233 12.3544C7.0172 11.7293 6.66602 10.8815 6.66602 9.9974C6.66602 9.11334 7.0172 8.26549 7.64233 7.64037C8.26745 7.01525 9.11529 6.66406 9.99935 6.66406C10.8834 6.66406 11.7312 7.01525 12.3564 7.64037C12.9815 8.26549 13.3327 9.11334 13.3327 9.9974C13.3327 10.4351 13.2465 10.8686 13.0789 11.273C12.9114 11.6774 12.6659 12.0449 12.3564 12.3544C12.0468 12.6639 11.6794 12.9095 11.275 13.077C10.8705 13.2445 10.4371 13.3307 9.99935 13.3307ZM9.99935 0.664062C7.52399 0.664062 5.15002 1.64739 3.39969 3.39773C1.64935 5.14807 0.666016 7.52204 0.666016 9.9974C0.666016 16.9974 9.99935 27.3307 9.99935 27.3307C9.99935 27.3307 19.3327 16.9974 19.3327 9.9974C19.3327 7.52204 18.3493 5.14807 16.599 3.39773C14.8487 1.64739 12.4747 0.664063 9.99935 0.664062Z",
    fill: "#ACACAC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLivetracksix);
export default __webpack_public_path__ + "static/media/livetracksix.8214d6c303933f080bb95c23502a8bf8.svg";
export { ForwardRef as ReactComponent };